export default () => ({
  meActived: false
})



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/resources/data.js